import { render } from "./MobDeals.vue?vue&type=template&id=4e160f3e&scoped=true"
import script from "./MobDeals.vue?vue&type=script&lang=js"
export * from "./MobDeals.vue?vue&type=script&lang=js"

import "./MobDeals.vue?vue&type=style&index=0&id=4e160f3e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e160f3e"]])

export default __exports__